<template>
  <el-dialog
    title="文章详情"
    :visible.sync="visible"
    width="80%"
    @close="close"
  >
    <div v-if="info != null" class="w">
      <div class="title">{{ info.title }}</div>
      <div class="time">
        <div>
         {{info.createdAt}}
        </div>
        <div class="label">文章选中</div>
      </div>
      <div class="img-wrap">
        <img :src="info.imgUrl" class="img" />
      </div>
      <div class="des d-m">
        {{ info.des }}
      </div>
      <div v-if="info != null">
        <div v-html="info.content"></div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import axios from "axios";
import Img from "../../components/Img.vue";
const moment=require('moment')
export default {
  name: "Role",
  data() {
    const that = this;
    return {
      loading: false,
      info: null,
      visible: false,
    };
  },
  components: { Img },
  async mounted() {},

  beforeDestroy() {},
  methods: {
    async setRow(row) {
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.visible = true;
      await this.initData(row.id);
      loading.close();
    },
    close() {
      this.visible = false;
    },
    async getConfig() {
      let r = await axios.get("/admin/get-config");
      if (r.code == 0) {
        this.imgHost = r.data.resoureHost;
      }
      return r;
    },
    async initData(id) {
      this.isEdit = true;

      let r = await axios.get("/admin/get-a-article", {
        params: {
          id: id,
        },
      });
      if (r.code == 0) {
        this.info = Object.assign(r.data,{createdAt:moment(r.data.createdAt).format("YYYY/MM/DD HH:mm:ss")});
      }
      return r;
    },
  },
};
</script>
<style scoped>
.title {
  font-size: 30px;
  font-weight: 700;
}
.time {
  font-size: 18px;
  color: #888;
  display: flex;
  align-content: center;
  margin:20px 0px;
}
.d-m{
    margin:10px 0px;

}
.des {
  color: #999;
  line-height: 36px;
  font-size: 24px;
}
.img-wrap {
  display: flex;
  justify-content: center;
}
.img {
  max-width: 300px;
}
.label{
  margin-left: 20px;
}

</style>



// WEBPACK FOOTER //
// src/main/admin/ArticleShow.vue